import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  TextField,
  Typography,
  Input,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import * as Yup from "yup";
import { useFormik } from "formik";
import MainContainer from "../../layout/MainContainer";
import { useNavigate, useParams } from "react-router-dom";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";
import { errorToast, successToast, warnToast } from "../../helpers";
import { useEditamenitiesMutation, useLazyGetSpecificamenitiesByIdQuery, usePostAddAmenitiesMutation } from "../../services/amenities";
import Loader from "../../helpers/constants/Loader";
import { UploadMedia } from "../../utils/uploadMedia";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { profile } from "console";

const AddAmenities = () => {
  const { _id } = useParams();
  const navigate = useNavigate();
  const [profilePicture, setProfilePicture] = useState("");
  const [fetchApi, { data }] = useLazyGetSpecificamenitiesByIdQuery();
  const [fetchAddCategory, { isLoading }] = usePostAddAmenitiesMutation();
  const [updateCategory] = useEditamenitiesMutation();




  const fetchDataById = async (id: any) => {
    try {
      const response = await fetchApi({ userId: id }).unwrap();
      if (response.statusCode === 200) {
        setProfilePicture(response?.data?.image || "");
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "")
    }
  };

  const handleImageUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;

    try {
      if (!file) {
        setProfilePicture("");
        return;
      }

      const res = await UploadMedia(file);
      if (res?.statusCode === 200) {
        const imageUrl = res?.data[0]?.location;
        setProfilePicture(imageUrl);
        successToast("Image uploaded successfully.");
      } else {
        errorToast(res?.message);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      errorToast("Error uploading image. Please try again.");
    }
  };

  const formik = useFormik({
    initialValues: {
      title: "",
      short_name: "",
    },
    validationSchema: Yup.object({
      title: Yup.string()
        .required("This field is required")
       
        .min(2, "Minimum 2 characters are required"),
      short_name: Yup.string()
        .required("This field is required")
       
        .min(2, "Minimum 2 characters are required"),
    }),
    onSubmit: async (values) => {

        

      const body = {
        name: values.title,
        image: profilePicture,
        short_name: values.short_name,

      };
      if (!_id)
        try {
          const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
          const response = await fetchAddCategory(encryptedBody).unwrap();
          if (response.statusCode === 200) {
            successToast(response.data.message || "Amenity Added Successfully");
            navigate("/manage-amenities/");
          } else {

            errorToast("error")
          }
        } catch (e: any) {
          //console.log(e);

          errorToast(e?.data?.message || e?.message || e?.data?.message);
        }

      else {
        try {
          const encryptedBody2 = generateEncryptedKeyBody(body) as CommonBody;

          const response = await updateCategory({
            id: _id,
            body: encryptedBody2,
          }).unwrap();

          if (response.statusCode === 200) {
            successToast("Amenity Updated Successfully");
            navigate("/manage-amenities/");
          } 
        } catch (e: any) {

          errorToast(e?.message || e?.data?.message );
        }


      }

    },
  });

  useEffect(() => {
    if (data && data.statusCode === 200) {
      formik.setValues({
        title: data?.data?.name || "",
        short_name: data?.data?.short_name || ""
      });
    }
  }, [data]);
  useEffect(() => {
    if (_id) {
      fetchDataById(_id);
    }
  }, [_id]);


  return (
    <>
      <div>
        <div className="main_loyout">
          <div className="dashboard">
            <h1>{_id ? "Edit Amenity" : "Add Amenity"}</h1>
            <Button
              className="btn btn_primary"
              onClick={() => {
                navigate("/manage-amenities");
              }}
            >
              Back
            </Button>
          </div>
          <Loader isLoad={isLoading} />
          <Card className="cards">
            <form onSubmit={formik.handleSubmit}>
              <CardContent sx={{ p: 1 }}>
                <Grid container spacing={2}>

                  <Grid item xs={12}>
                    <Typography className="custom_label">Image</Typography>
                    {profilePicture ? (
                      <div className="upload_image_preview">
                        <CardMedia
                          component="img"
                          style={{ borderRadius: 0 }}
                          image={profilePicture}
                          alt="photo"
                        />
                        <CancelIcon
                          onClick={(e) => {
                            e.preventDefault();
                            setProfilePicture("");
                          }}
                        />
                      </div>
                    ) : (
                      <Box className="upload_image">
                        <label htmlFor="icon-button-file">
                          <Input
                            sx={{ display: "none" }}
                            id="icon-button-file"
                            type="file"
                            inputProps={{
                              accept: "image/png,image/jpeg",
                            }}
                            onChange={handleImageUpload}
                          />
                          <Button
                            component="span"
                            className="upload_image_btn"
                          >
                            <img
                              style={{ borderRadius: 0 }}
                              src="/static/images/product1.png"
                              alt=""
                            />
                            <CameraAltIcon />
                          </Button>
                        </label>

                      </Box>
                    )}
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Typography className="custom_label">
                      Amenity Name
                    </Typography>
                    <TextField
                      hiddenLabel

                      type={"text"}
                      name="title"
                      variant="outlined"
                      fullWidth
                      value={formik.values.title}
                      placeholder="Amenity Name"
                      className="text_field"
                      onBlur={formik.handleBlur}
                      onChange={(val) => {
                        if (
                          val.target.value === " "

                        ) {
                        } else {
                          formik.handleChange(val);
                        }
                      }}
                      helperText={
                        formik.touched.title && formik.errors.title
                          ? formik.errors.title.toString()
                          : ""
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Typography className="custom_label">
                      Amenity Short name
                    </Typography>
                    <TextField
                      hiddenLabel

                      type={"text"}
                      name="short_name"
                      variant="outlined"
                      fullWidth
                      value={formik.values.short_name}
                      placeholder="Short Name"
                      className="text_field"
                      onBlur={formik.handleBlur}
                      onChange={(val) => {
                        if (
                          val.target.value === " "

                        ) {
                        } else {
                          formik.handleChange(val);
                        }
                      }}
                      helperText={
                        formik.touched.short_name && formik.errors.short_name
                          ? formik.errors.short_name.toString()
                          : ""
                      }
                    />
                  </Grid>
                </Grid>
                <div className="form_btn">
                  <Button
                    size="large"
                    type="submit"
                    className="btn btn_primary"
                  >
                    Save
                  </Button>
                </div>
              </CardContent>
            </form>
          </Card>
        </div>
      </div>
    </>
  );
};

export default AddAmenities;
